import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

import { Patient } from '../patient';
import { PatientService } from '../../service/patient.service';

@Component({
  selector: 'mc-patient-show',
  templateUrl: './patient-show.component.html',
  styleUrls: ['./patient-show.component.scss']
})
export class PatientShowComponent implements OnInit {

  patient: Patient;

  constructor(
    private patientService: PatientService,
    private route: ActivatedRoute,
    private location: Location,
    private notifService: ToastrService 
  ) { }

  ngOnInit() {
    this.getPatient();
  }

  getPatient(): void {
    const id = +this.route.snapshot.paramMap.get('id');
    this.patientService.getPatient(id).subscribe(
      patient => this.patient = patient
    );
  }

  savePatient(): void {
     if (this.patient) {
      this.patientService.updatePatient(this.patient).subscribe(
        patient => {
          this.notifService.success('Paciente atualizado');
          this.location.back();
        },
        error => this.notifService.error(error)
      );
    }
  }

  goBack(): void {
    this.location.back();
  }
}
